module.exports = __webpack_public_path__ + "img/brackets-round.31631015.svg";